export default [
  {
    path: '',
    name: 'servicios',
    component: () => import(/* webpackChunkName: "apps-servicios" */ '@/apps/servicios/pages/ServiciosPage.vue')
  },
  {
    path: 'padres',
    name: 'servicios-padres',
    component: () => import(/* webpackChunkName: "apps-servicios-padres" */ '@/apps/servicios/pages/ServiciosPadresPage.vue')
  }
]
